import { Button, Menu, MenuItem, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import {
  getStreams,
  resetMetaContactList,
} from "../../service/IntegrationsSlice";
import {
  resetStreamById,
  getStreamById,
} from "../../service/IntegrationsSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import styles from "./Meta.module.css";
import AddIcon from "@mui/icons-material/Add";
import StreamsTab from "./components/Tabs/StreamsTab";
import ResponsesTab from "./components/Tabs/ResponsesTab";
import CreditTab from "./components/Tabs/CreditTab";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import PageBackBtn from "../../../../../components/Buttons/PageBackBtn";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function MetaIntegration(props: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userById } = useSelector((state: any) => state.userDetails);

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const [executeFunc, setExecuteFunc] = useState(true);
  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);

  const { metaStreams, streamsLoading } = useSelector(
    (state: any) => state.appIntegrations
  );
  const [value, setValue] = useState<number>(0);
  const [connectStage, setConnectStage] = useState<Number>(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [streamType, setStreamType] = useState<string>("ALL");

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue == 1) {
      dispatch(resetStreamById());
      dispatch(resetMetaContactList());
    }
    setValue(newValue);
  };

  const handleExecuteFunonLoad = () => {
    setExecuteFunc(false);
  };

  const handleTabSelect = (value: any, id?: string) => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("tabOpen", value);
    queryParams.delete("streamId");
    /* 	if (value === 'streams') {
			setConnectStage(0);
		} else {
			queryParams.delete('streamSearchTerm');
		} */
    if (value !== "streams") {
      queryParams.delete("streamSearchTerm");
    } else {
      setConnectStage(0);
    }

    if (value === "responses" && typeof id === "string" && id.trim() !== "") {
      queryParams.set("streamId", id);
      setExecuteFunc(true);
    }

    const queryString = queryParams.toString();
    const newUrl = queryString
      ? `${window.location.pathname}?${queryString}`
      : window.location.pathname;

    window.history.pushState({}, "", newUrl);
    if (value !== "creditdistribution") {
      /* dispatch<any>(
				getStreams({
					id: activeInstitute?.id,
					status: '',
					branchId: '',
				})
			); */
    }
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value: any) => {
    setAnchorEl(null);
  };

  const handleStreamType = (value: any) => {
    if (value) setStreamType(value);

    dispatch<any>(
      getStreams({
        id: activeInstitute?.id,
        status: value === "ALL" ? "" : value,
        branchId: hasAllBranchAccess ? "" : userById?.branchId,
      })
    );
    setAnchorEl(null);
  };
  const handleUpdateValue = (value: number) => {
    if (value == 1) {
      dispatch(resetStreamById());
      dispatch(resetMetaContactList());
      setExecuteFunc(true);
    }
    setValue(value);
  };

  const createStream = (item: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set("streamStage", "1");
    const newUrl = `${window.location.pathname}?${urlSearchParams.toString()}`;
    window.history.pushState({}, "", newUrl);
    setConnectStage(1);
  };

  const handleGoBack = () => {
    navigate("/app/Integrations");
  };

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const tabOpen = urlSearchParams.get("tabOpen");
    const streamStage = urlSearchParams.get("streamStage");

    if (tabOpen) {
      switch (tabOpen) {
        case "responses":
          setValue(1);
          break;
        case "creditdistribution":
          setValue(2);
          break;
        default:
          setValue(0);
          break;
      }
    }

    if (streamStage) {
      switch (streamStage) {
        case "1":
          setConnectStage(1);
          break;
        case "2":
          setConnectStage(2);
          break;
        default:
          setConnectStage(0);
          break;
      }
    }
  }, []);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const metaCode = urlSearchParams.get("code");
    const metaState = urlSearchParams.get("state");
    if (metaCode && metaState) {
      setConnectStage(1);
    }
  }, []);

  return (
    <div
      style={{
        overflow: "hidden",
        maxHeight: "calc(100vh - 65px)",
        position: "relative",
      }}
    >
      <div className={styles.leadStreamHeader}>
        <div className={styles.leadStreamHeaderLeft}>
          <div style={{ marginRight: "10PX" }}>
            <PageBackBtn
              onClick={handleGoBack}
              width={"30px"}
              icon={<ArrowBackIcon />}
              text={false}
            />
          </div>

          <div className={styles.leadStreamHeaderTitle}>Lead Stream</div>
          <div className={styles.leadStreamHeaderTabs}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="billing tabs"
              sx={{
                ml: 2,
                backgroundColor: "white",
                // height: "36px",
                // minHeight: "36px",
                minHeight: "60px",
                "& .MuiTabs-flexContainer": {
                  gap: "24px",
                },
                "& .MuiTabs-indicator": {
                  height: "2.5px",
                },
              }}
            >
              <Tab
                label="Streams"
                {...a11yProps(0)}
                sx={{
                  textTransform: "capitalize",
                  padding: "0",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "24px",
                  color: "#142C4480",
                  minWidth: "fit-content",
                  // height: "36px",
                  // minHeight: "36px",
                  minHeight: "60px",
                  "&.Mui-selected": {
                    color: "#142C44",
                    fontWeight: "700",
                  },
                }}
                onClick={() => {
                  handleTabSelect("streams");
                }}
              />
              <Tab
                label="Responses"
                {...a11yProps(1)}
                sx={{
                  textTransform: "capitalize",
                  padding: "0",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "24px",
                  color: "#142C4480",
                  minWidth: "fit-content",
                  // height: "36px",
                  // minHeight: "36px",
                  minHeight: "60px",
                  "&.Mui-selected": {
                    color: "#142C44",
                    fontWeight: "700",
                  },
                }}
                onClick={() => {
                  handleTabSelect("responses");
                }}
              />
              <Tab
                label="Credit Distribution"
                {...a11yProps(1)}
                sx={{
                  textTransform: "capitalize",
                  padding: "0",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "24px",
                  color: "#142C4480",
                  minWidth: "fit-content",
                  // height: "36px",
                  // minHeight: "36px",
                  minHeight: "60px",
                  "&.Mui-selected": {
                    color: "#142C44",
                    fontWeight: "700",
                  },
                }}
                onClick={() => {
                  handleTabSelect("creditdistribution");
                }}
              />
            </Tabs>
          </div>
        </div>
        {value === 0 && connectStage === 0 && (
          <div className={styles.leadStreamHeaderRight}>
            <Button
              variant="contained"
              onClick={handleClick}
              endIcon={<ArrowDropDownIcon />}
              sx={{
                textTransform: "capitalize",
                fontSize: "14px",
                fontWeight: "500",
                background: "#073E53",
                minWidth: "168px",
                ":hover": {
                  background: "#073E53",
                },
              }}
              disabled={metaStreams?.length === 0 && streamType === "ALL"}
            >
              {`${
                streamType?.replace(/_/g, " ").toLowerCase() +
                " " +
                "Streams" +
                " " +
                `(${metaStreams ? metaStreams?.length : 0})`
              }`}
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => handleClose(null)}
              PaperProps={{
                style: {
                  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.06)",
                  borderRadius: "4PX",
                  border: "1px solid #E4E4E7",
                  minWidth: "168px",
                },
              }}
            >
              {[
                { value: "ALL" },
                { value: "ACTIVE" },
                { value: "INACTIVE" },
                { value: "DRAFT" },
              ]?.map((item: any, index: number) => (
                <MenuItem
                  key={index}
                  onClick={() => handleStreamType(item?.value)}
                  sx={{
                    textTransform: "capitalize",
                    color: "#142C4480",
                    fontSize: "12px",
                  }}
                >
                  {`${
                    item?.value?.replace(/_/g, " ").toLowerCase() +
                    " " +
                    "Streams"
                  }`}
                </MenuItem>
              ))}
            </Menu>
            {metaStreams?.length === 0 && streamType === "ALL" ? (
              <></>
            ) : (
              <Button
                variant="contained"
                color="primary"
                sx={{
                  fontSize: 14,
                  textTransform: "capitalize",
                  boxShadow: "none",
                  height: "38px",
                }}
                size={"small"}
                onClick={createStream}
              >
                <AddIcon sx={{ marginRight: "10px", fontSize: "18px" }} />
                Create new stream
              </Button>
            )}
          </div>
        )}
      </div>
      <div className={styles.metaTabContentWrap}>
        {value === 0 && (
          <StreamsTab
            connectStage={connectStage}
            setConnectStage={setConnectStage}
            metaStreams={metaStreams}
            setValue={setValue}
            streamsLoading={streamsLoading}
            handleTabSelect={handleTabSelect}
            handleTabChange={handleUpdateValue}
            createStream={createStream}
            streamType={streamType}
          />
        )}
        {value === 1 && (
          <ResponsesTab
            executeFunc={executeFunc}
            handleExecuteFunonLoad={handleExecuteFunonLoad}
          />
        )}
        {value === 2 && (
          <CreditTab
            handleTabSelect={handleTabSelect}
            handleTabChange={handleUpdateValue}
          />
        )}
      </div>
    </div>
  );
}

export default MetaIntegration;
